import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { api, get } from "../../../../../utils/api";
import DisableFutureDate from "../../../../../Components/Masters/DisableFutureDate";
import contries from "../../../Roles and Permissions/Country.json";
import SelectField from "../../../../../Components/Masters/SelectField";
import EmailField1 from "../../../../../Components/Masters/EmailField1";
import PhoneInput from "../../../../../Components/Masters/PhoneInput";
import MESSAGES from "../../../../../utils/message";
import FileField from "../../../../../Components/Masters/FileField";
import PhoneInputField from "../../../../../Components/Masters/PhoneInputField";
import { validateNumber } from "../../../../../utils/validateFields";
import EditDialog from "../../../../../Components/Common/EditDialog";
import { idDocuments } from "./CountryDocuments";
import { europeanCountries } from "../../../../../utils/countriesArray";
import DateField from "../../../../../Components/Masters/DateField";

function AddDriver(props) {
  const [alreadyFacility, setAlreadyFacility] = useState(false);
  const [facilities, setFacilities] = useState(["Select Faciltiy"]);
  const [vendor, setVendors] = useState(["Select"]);
  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [uploadedAadharDocs, setUploadedAadharDocs] = useState([]);
  const [aadharUploadProgress, setAadharUploadProgress] = useState({});

  const [uploadedLicenseDocs, setUploadedLicenseDocs] = useState([]);
  const [licenseUploadProgress, setLicenseUploadProgress] = useState({});
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: "55%",
        overflowY: "auto",
      },
    },
  };

  console.log("isnide add", props);

  const verifyData = {
    phone: false,
    email: false,
    emailMsg: "",
    phoneMsg: "",
  };
  const [verify, setVerify] = useState(verifyData);

  const element = {
    email: props.selectedFacility?.email || null,
    phone: props.selectedFacility?.phone || null,
  };
  const [editDialog, setEditDialog] = useState(false);

  const taskIntial = {
    phone: false,
    email: false,
  };
  const [TaskAltIcons, setTaskAltIcons] = useState(taskIntial);

  const [otp, setOTP] = useState({
    phone: null,
    email: null,
  });

  const [errors, setErrors] = useState({});

  const initialState = {
    facility: props?.selectedFacility?.facility?._id ?? "",
    logisticsVendor: props?.selectedFacility?.logisticsVendor?._id ?? "",
    ownershipType: props?.selectedFacility?.ownershipType ?? "Owned",
    driverName: props?.selectedFacility?.driverName ?? "",
    aadharNumber: props?.selectedFacility?.aadharNumber ?? "",
    licenseNumber: props?.selectedFacility?.licenseNumber ?? "",
    licenseExpiryDate: props?.selectedFacility?.licenseExpiryDate ?? "",
    phone: props?.selectedFacility?.phone ?? "",
    email: props.selectedFacility?.email ?? "",
    countryCode: props?.selectedFacility?.countryCode ?? "",
    licenseDoc: props?.selectedFacility?.licenseDoc ?? [],
    aadharDoc: props?.selectedFacility?.aadharDoc ?? [],
    country: props?.selectedFacility?.country ?? "",
  };
  const [formData, setFormData] = useState([]);
  const [formData2, setFormData2] = useState([]);
  const [regex, setRegex] = useState({});

  useEffect(() => {
    fetchFacilities();

    handleResetForm();
  }, [props.selectedFacility]);

  const handleResetForm = () => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedAadharDocs(props.selectedFacility?.aadharDoc ?? []);
    setUploadedLicenseDocs(props.selectedFacility?.licenseDoc ?? []);
    setAlreadyFacility(props?.selectedFacility?._id ? true : false);
    // props.setAddFacility(props?.selectedFacility?._id ? true:false);
  };

  useEffect(() => {
    if (props.selectedFacility?.email && props.selectedFacility?.phone) {
      setTaskAltIcons({ ...TaskAltIcons, phone: true, email: true });
    } else if (
      !props.selectedFacility?.email &&
      !props.selectedFacility?.phone
    ) {
      setTaskAltIcons({ ...TaskAltIcons, phone: false, email: false });
    }
  }, [props]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let length = null;

    console.log(name, "REGEX");
    // if (name === "aadharNumber" || name === "licenseNumber") {
    //   length =
    //     name === "aadharNumber"
    //       ? requiredLength(regex?.key3regex)
    //       : requiredLength(regex?.key4regex ?? regex?.key3regex);

    //   console.log(length, value?.length, "regex");

    // }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

    // if (
    //   (name === "aadharNumber" || name === "licenseNumber") &&
    //   value?.length > 0
    // ) {
    //   const regex1 = new RegExp(
    //     name === "aadharNumber"
    //       ? regex?.key3regex
    //       : regex?.key4regex ?? regex?.key3regex
    //   );
    //   console.log(
    //     regex1,
    //     length,
    //     name,
    //     "regex",
    //     value?.length,
    //     regex1.test(value),
    //     value
    //   );

    //   if (!regex1.test(value)) {
    //     setErrors({
    //       ...errors,
    //       [name]: `Invalid Format`,
    //     });
    //   }
    // }
  };

  const handleCountryChange = (event) => {
    const selectedCountryCode = event.target.value;
    setErrors({ ...errors, country: "" });

    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode
    );

    if (selectedCountry) {
      setFormData({
        ...formData,
        phone: "",
        country: selectedCountry.name,
        countryCode: selectedCountry.dial_code,
        aadharDoc: "",
        aadharNumber: "",
        licenseDoc: "",
        licenseNumber: "",
      });
    }
    if (selectedCountry.dial_code && formData.phone !== "") {
      setVerify({ ...verify, phone: true });
      setTaskAltIcons({ ...TaskAltIcons, phone: false });
      setErrors({ ...errors, [event.target.name]: "" });
    }
    setRegex({
      ...europeanCountries?.find(
        (i) => i?.countryName === selectedCountry.name
      ),
    });
  };

  const handleDateChange = ({ name, value }) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setErrors({ ...errors, licenseExpiryDate: "" });
  };

  const fetchFacilities = async () => {
    try {
      const response = await get("/master/getAllFacility");
      const result = await get(`/master/logistic/vendorMaster`);

      setFacilities(response.data.data);
      setVendors(result.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const Save = (e) => {
    e.preventDefault();
    const dataToSubmit = {
      ...formData,
      aadharDoc: uploadedAadharDocs,
      licenseDoc: uploadedLicenseDocs,
    };
    if (!validateForm()) {
      return;
    }
    const token = sessionStorage.getItem("token");
    axios({
      method: alreadyFacility ? "put" : "post",
      url: alreadyFacility
        ? `${api}/driver/master/update`
        : `${api}/driver/master/create`,
      data: dataToSubmit,
      params: alreadyFacility ? { id: props.selectedFacility?._id } : null,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        props.setAddFacility(false);
        props.fetchFacilities();
        props.setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        handleExitAgree();
      })
      .catch((err) => {
        const errorData = err?.response?.data;

        if (Array.isArray(errorData?.commonKeyMsg)) {
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            errorData.commonKeyMsg.forEach(({ key, msg }) => {
              newErrors[key] = msg;
            });
            return newErrors;
          });
        } else if (errorData?.errorKey && errorData?.message) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [errorData.errorKey]: errorData.message,
          }));
        }
      });
  };

  const getDropDownFieldId = (data) => {
    if (typeof data === "string") {
      return data;
    }
    return data?._id || "";
  };

  const validateForm = () => {
    const newErrors = {};
    const {
      facility,
      logisticsVendor,
      driverName,
      aadharNumber,
      licenseNumber,
      email,
      licenseExpiryDate,
      aadharDoc,
      licenseDoc,
      phone,
      countryCode,
      country,
    } = formData;

    if (!country || country === "Select Country") {
      newErrors.country = "Please select a country.";
    }
    if (errors.phone) {
      newErrors.phone = "Phone number already registered.";
    }

    if (phone === "") {
      newErrors.phone = "Phone number is required.";
    } else if (!validateNumber(phone) || phone?.length < 7) {
      newErrors.phone = "Please enter valid Phone number";
    }

    if (!logisticsVendor || logisticsVendor === "Select") {
      newErrors.logisticsVendor = "Please select a logistics vendor.";
    }

    if (!driverName || driverName.trim() === "") {
      newErrors.driverName = "Driver name is required.";
    }

    if (!licenseNumber || licenseNumber.trim() === "") {
      newErrors.licenseNumber = "License number is required.";
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // if (!email) {
    //   newErrors.email = "Email Required";
    // } else if (!emailRegex.test(email)) {
    //   newErrors.email = "Please enter a valid email address.";
    // }
    // else if (!TaskAltIcons.email) {
    //   if (verify.email) {
    //     setVerify((prev) => ({ ...prev, emailMsg: "OTP is required" }));
    //   }
    //   if (errors.email) {
    //     newErrors.email = "Email already registered.";
    //   } else {
    //     newErrors.email = MESSAGES.EMAIL_VERIFICATION_REQUIRED;
    //   }
    // }

    const currentDate = new Date();
    if (!licenseExpiryDate) {
      newErrors.licenseExpiryDate = "License expiry date is required.";
    }

    const regex1 = new RegExp(regex?.key3regex || "^\\d{12}$");

    if (!aadharNumber || aadharNumber === "") {
      newErrors.aadharNumber = (regex?.key3 || "Govt. ID") + " is required.";
    }
    // else if (
    //   // aadharNumber?.length !== requiredLength(regex1) ||
    //   !regex1.test(aadharNumber)
    // ) {
    //   newErrors.aadharNumber = `Invalid Format`;
    // }

    const regex2 = new RegExp(regex?.key4regex ?? regex?.key3regex);

    if (!licenseNumber || licenseNumber === "") {
      newErrors.licenseNumber = `License is required.`;
    }
    //  else if (
    //   // licenseNumber?.length !== requiredLength(regex2) ||
    //   !regex2.test(licenseNumber)
    // ) {
    //   newErrors.licenseNumber = `Invalid Format`;
    // }

    if (!uploadedAadharDocs || uploadedAadharDocs.length === 0) {
      newErrors["aadharDoc"] = "Please upload a Gov. ID.";
    }

    if (!uploadedLicenseDocs || uploadedLicenseDocs.length === 0) {
      newErrors["licenseDoc"] = "Please upload a License.";
    }

    console.log(newErrors, "newE");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );

    const isFilesUnchanged =
      JSON.stringify(uploadedAadharDocs) ===
      JSON.stringify(formData2?.aadharDoc || []);

    const isLicenseDocs =
      JSON.stringify(uploadedLicenseDocs) ===
      JSON.stringify(formData2?.licenseDoc || []);

    console.log(
      isFormDataUnchanged,
      formData,
      formData2,
      "isChanged",
      isFilesUnchanged,
      isLicenseDocs,
      uploadedAadharDocs,
      uploadedLicenseDocs
    );
    if (isFormDataUnchanged && isFilesUnchanged && isLicenseDocs) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedAadharDocs(props?.selectedFacility?.aadharDoc ?? []);
    setUploadedLicenseDocs(props?.selectedFacility?.licenseDoc ?? []);
    setTaskAltIcons(taskIntial);
    setOTP({
      phone: null,
      email: null,
    });
    setverifybtn(verifyData);
    setErrors({});
    props.setAddFacility(false);
    setEditDialog(false);
    setVerify({ email: false, phone: false, emailMsg: "", phoneMsg: "" });
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.selectedFacility?._id === undefined
            ? "Add Driver"
            : "Edit Driver"}
        </Typography>
        {/* 
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
        >
          Facility
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          fullWidth
          name="facility"
          onChange={handleChange}
          value={
            formData?.facility === "" || undefined
              ? "Tap to Select"
              : getDropDownFieldId(formData.facility)
          }
          placeholder="Select Facility"
          error={!!errors.facility}
          InputLabelProps={{
            style: { color: errors.facility ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
        >
          <MenuItem
            value={
              formData?.facility === "" || undefined
                ? "Tap to Select"
                : formData?.facility
            }
            disabled
          >
            {formData?.facility === "" || undefined
              ? "Tap to Select"
              : formData?.facility?.facilityName || formData?.facility}
          </MenuItem>
          {facilities.map((item, i) => (
            <MenuItem key={i} value={item._id}>
              {item?.facilityName}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.facility && (
          <Typography variant="body2" color="#D34040">
            {errors.facility}
          </Typography>
        )} */}

        <SelectField
          title={"Country"}
          name={"country"}
          value={formData.country}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors["country"]}
        />

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Logistics Vendor
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          fullWidth
          name="logisticsVendor"
          value={
            formData.logisticsVendor === "" || undefined
              ? "Tap to Select"
              : getDropDownFieldId(formData.logisticsVendor)
          }
          onChange={handleChange}
          placeholder="Select logisticsVendor"
          error={!!errors.logisticsVendor}
          InputLabelProps={{
            style: { color: errors.logisticsVendor ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
        >
          <MenuItem value="Tap to Select">Tap to Select</MenuItem>
          {vendor.map((item) => (
            <MenuItem key={`equipment_${item._id}`} value={item._id}>
              {item.logisticVendorLegalName}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.logisticsVendor && (
          <Typography variant="body2" color="#D34040">
            {errors.logisticsVendor}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Driver's Name
        </Typography>
        <CustomTextField
          variant="outlined"
          value={formData.driverName}
          onChange={handleChange}
          fullWidth
          name="driverName"
          placeholder="Driver's Name"
          error={!!errors.driverName}
          InputLabelProps={{
            style: { color: errors.driverName ? "#D34040" : undefined },
          }}
        />
        {errors.driverName && (
          <Typography variant="body2" color="#D34040">
            {errors.driverName}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          {europeanCountries?.find(
            (el) => el?.countryName === formData?.country
          )?.key3 || "Govt. ID Number"}
        </Typography>
        <CustomTextField
          variant="outlined"
          value={formData.aadharNumber}
          onChange={handleChange}
          fullWidth
          name="aadharNumber"
          placeholder={
            europeanCountries?.find(
              (el) => el?.countryName === formData?.country
            )?.key3 || "Govt. ID Number"
          }
          error={!!errors.aadharNumber}
          InputLabelProps={{
            style: { color: errors.aadharNumber ? "#D34040" : undefined },
          }}
        />
        {errors.aadharNumber && (
          <Typography variant="body2" color="#D34040">
            {errors.aadharNumber}
          </Typography>
        )}
        {/* drivering license */}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Driving License Number
        </Typography>
        <CustomTextField
          variant="outlined"
          value={formData.licenseNumber}
          onChange={handleChange}
          fullWidth
          name="licenseNumber"
          placeholder="Driving License Number"
          error={!!errors.licenseNumber}
          InputLabelProps={{
            style: { color: errors.licenseNumber ? "#D34040" : undefined },
          }}
        />
        {errors.licenseNumber && (
          <Typography variant="body2" color="#D34040">
            {errors.licenseNumber}
          </Typography>
        )}
        <DateField
          title="License Expiry Date"
          name="licenseExpiryDate"
          placeholder="License Expiry Date"
          value={formData.licenseExpiryDate}
          handleChange={handleDateChange}
          errors={!!errors?.licenseExpiryDate}
          minToday={true}
          noMaxDate={true}
        />

        <PhoneInputField
          title="Driver's Phone Number"
          value={formData.phone || ""}
          fieldName="phone"
          placeholder="Enter Phone Number"
          countryCode={formData.countryCode}
          setFormData={setFormData}
          formData={formData}
          showIcon={TaskAltIcons.phone}
          setErrors={setErrors}
          errors={errors?.phone}
          element={element}
          verify={verify}
          setVerify={setVerify}
          verifybtn={verifybtn}
          setverifybtn={setverifybtn}
          TaskAltIcons={TaskAltIcons}
          setTaskAltIcons={setTaskAltIcons}
        />
        {console.log("errr", errors)}
        <EmailField1
          title="Email"
          placeholder="Enter Driver's Email"
          value={formData?.email || ""}
          errors={errors?.email}
          fieldName="email"
          {...{
            setTaskAltIcons,
            TaskAltIcons,
            setErrors,
            setFormData,
            element,
            formData,
            setVerify,
            verify,
            setverifybtn,
            verifybtn: "",
          }}
        />

        <FileField
          title={"Upload Gov. ID"}
          name={"aadharDoc"}
          errors={errors["aadharDoc"]}
          fileUrls={uploadedAadharDocs}
          progress={aadharUploadProgress["aadharDoc"] || []}
          {...{
            setUploadedFiles: setUploadedAadharDocs,
            setUploadProgress: setAadharUploadProgress,
            setErrors,
          }}
          multiple
        />
        {errors.uploadedAadharDocs ? (
          <Typography variant="body2" color="#D34040"></Typography>
        ) : (
          ""
        )}

        <FileField
          title={`Upload License`}
          name={"licenseDoc"}
          errors={errors["licenseDoc"]}
          fileUrls={uploadedLicenseDocs}
          progress={licenseUploadProgress["licenseDoc"] || []}
          {...{
            setUploadedFiles: setUploadedLicenseDocs,
            setUploadProgress: setLicenseUploadProgress,
            setErrors,
          }}
          multiple
        />
        {errors.uploadedLicenseDocs ? (
          <Typography variant="body2" color="#D34040"></Typography>
        ) : (
          ""
        )}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0a3f73",
            textTransform: "none",
            marginTop: "10%",
          }}
          onClick={Save}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.addFacility}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddDriver;

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
  "& .MuiSelect-select": {
    height: "56px",
    display: "flex",
    alignItems: "center",
  },
}));
